/* Imagine Fashion product-card enhancements — shared and cached once. */
(function(){
  if (window._ifCardImageArrowsReady) return;
  window._ifCardImageArrowsReady = true;

  var productJsonCache = {};

  function getCardGallery(card) {
    if (!card) return [];

    var galleryJson = card.getAttribute('data-if-gallery-images') || '[]';

    if (card._ifGalleryImages && card._ifGalleryImagesJson === galleryJson) return card._ifGalleryImages;

    try {
      card._ifGalleryImages = JSON.parse(galleryJson);
    } catch (e) {
      card._ifGalleryImages = [];
    }

    card._ifGalleryImagesJson = galleryJson;

    return card._ifGalleryImages;
  }

  function getMainImage(card) {
    if (!card) return null;

    return card.querySelector('.t4s-product-inner picture img:not(.if-card-image-preload)') ||
      card.querySelector('.t4s-product-inner img.t4s-product-main-img:not(.if-card-image-preload)') ||
      card.querySelector('.t4s-product-inner img:not(.if-card-image-preload)');
  }

  function createMainImage(card) {
    if (!card) return null;

    var inner = card.querySelector('.t4s-product-inner');
    if (!inner) return null;

    var target = inner.querySelector('.t4s_ratio') ||
      inner.querySelector('a') ||
      inner;
    var image = document.createElement('img');

    image.className = 't4s-product-main-img';
    image.loading = 'lazy';
    image.decoding = 'async';
    image.style.width = '100%';
    image.style.height = '100%';
    image.style.objectFit = 'cover';
    image.style.display = 'block';

    target.appendChild(image);

    return image;
  }

  function showImageMedia(card, image) {
    if (!card || !image) return;

    card.querySelectorAll('.t4s-product-inner video, .t4s-product-inner iframe, .t4s-product-inner model-viewer').forEach(function(media) {
      if (media.pause) media.pause();
      media.style.display = 'none';
    });

    image.hidden = false;
    image.style.display = image.style.display === 'none' ? '' : image.style.display;

    var picture = image.closest('picture');
    if (picture) picture.style.display = '';
  }

  function getMediaMount(card) {
    if (!card) return null;

    var inner = card.querySelector('.t4s-product-inner');
    if (!inner) return null;

    return inner.querySelector('.t4s_ratio') ||
      inner.querySelector('a') ||
      inner;
  }

  function showVideoPoster(card, item) {
    if (!card || !item || !item.poster) return;

    var image = getMainImage(card) || createMainImage(card);
    if (!image) return;

    var picture = image.closest('picture');
    if (picture && item.posterSrcset) {
      picture.querySelectorAll('source').forEach(function(source) {
        source.setAttribute('srcset', item.posterSrcset);
        source.setAttribute('data-srcset', item.posterSrcset);
      });
    }

    if (item.posterSrcset) {
      image.setAttribute('srcset', item.posterSrcset);
      image.setAttribute('data-srcset', item.posterSrcset);
    }

    image.setAttribute('src', item.poster);
    image.setAttribute('data-src', item.poster);
    image.setAttribute('data-master', item.poster);
    if (item.alt) image.setAttribute('alt', item.alt);

    showImageMedia(card, image);
  }

  function getDynamicVideo(card) {
    return card ? card.querySelector('.if-card-dynamic-video') : null;
  }

  function removeDynamicVideo(card) {
    var dynamicVideo = getDynamicVideo(card);
    if (!dynamicVideo) return;

    if (dynamicVideo.pause) dynamicVideo.pause();
    dynamicVideo.remove();
  }

  function hideCardMotionMedia(card) {
    if (!card) return;

    card.querySelectorAll('.t4s-product-inner video, .t4s-product-inner iframe, .t4s-product-inner model-viewer').forEach(function(media) {
      if (media.pause) media.pause();
      media.style.display = 'none';
    });
  }

  function clearDynamicVideoForProductChange(card) {
    if (!card) return;

    removeDynamicVideo(card);
    hideCardMotionMedia(card);

    var image = getMainImage(card);
    if (image && image.getAttribute('src')) showImageMedia(card, image);
  }

  function createDynamicVideo(card, item) {
    if (!card || !item || !item.src) return null;

    var mount = getMediaMount(card);
    if (!mount) return null;

    removeDynamicVideo(card);

    var video = document.createElement('video');
    video.className = 'if-card-dynamic-video';
    video.muted = true;
    video.loop = true;
    video.autoplay = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.style.width = '100%';
    video.style.height = '100%';
    video.style.objectFit = 'cover';
    video.style.display = 'block';

    if (item.poster) video.setAttribute('poster', item.poster);
    if (item.alt) video.setAttribute('aria-label', item.alt);

    if (item.sources && item.sources.length) {
      item.sources.forEach(function(source) {
        var sourceEl = document.createElement('source');
        sourceEl.src = source.url;
        if (source.mimeType) sourceEl.type = source.mimeType;
        video.appendChild(sourceEl);
      });
    } else {
      video.src = item.src;
    }

    mount.appendChild(video);

    return video;
  }

  function showVideoMedia(card, item) {
    if (!card) return;

    if (item && item.type === 'external_video') {
      showVideoPoster(card, item);
      return;
    }

    var image = getMainImage(card);
    if (image) {
      image.style.display = 'none';

      var picture = image.closest('picture');
      if (picture) picture.style.display = 'none';
    }

    var visibleVideo = item && item.src ? createDynamicVideo(card, item) : null;

    card.querySelectorAll('.t4s-product-inner video, .t4s-product-inner iframe, .t4s-product-inner model-viewer').forEach(function(media) {
      if (visibleVideo && media !== visibleVideo && media.pause) media.pause();
      if (visibleVideo && media !== visibleVideo) {
        media.style.display = 'none';
        return;
      }

      media.style.display = '';
      if (media.play) {
        var playPromise = media.play();
        if (playPromise && playPromise.catch) playPromise.catch(function(){});
      }
    });
  }

  function preloadUrl(src, srcset) {
    if (!src) return;

    var img = new Image();
    if (srcset) img.srcset = srcset;
    img.src = src;
  }

  function wrapGalleryIndex(index, length) {
    if (!length) return 0;
    return ((index % length) + length) % length;
  }

  function getHandleFromHref(href) {
    if (!href) return '';

    var match = String(href).match(/\/products\/([^?#\/]+)/);
    return match ? match[1] : '';
  }

  function getCurrentProductHandle(card) {
    if (!card) return '';

    var productLink = card.querySelector('.t4s-product-title a[href*="/products/"]') ||
      card.querySelector('a[data-pr-href][href*="/products/"]') ||
      card.querySelector('.t4s-full-width-link[href*="/products/"]') ||
      card.querySelector('a[href*="/products/"]');

    return productLink ? getHandleFromHref(productLink.getAttribute('href')) : '';
  }

  function getSwatchProductHandle(swatch) {
    if (!swatch) return '';

    /*
      Important: in Kalles colour swatches, generic data-handle can be the colour handle
      only, for example "positano-blue", not the actual product handle. If we use that
      as the product handle, /products/positano-blue.js fails and the secondary badge
      stays hidden after switching away and back.

      So we only trust real product URLs or product-specific attributes first.
      Generic data-handle is intentionally ignored here unless it is supplied through
      a product URL attribute that contains /products/.
    */
    var candidates = [];

    var link = swatch.closest('a[href*="/products/"]') || (swatch.querySelector && swatch.querySelector('a[href*="/products/"]'));
    if (link) candidates.push(getHandleFromHref(link.getAttribute('href')));

    candidates.push(
      getHandleFromHref(swatch.getAttribute('href')),
      getHandleFromHref(swatch.getAttribute('data-href')),
      getHandleFromHref(swatch.getAttribute('data-url')),
      getHandleFromHref(swatch.getAttribute('data-pr-href')),
      getHandleFromHref(swatch.getAttribute('data-product-url')),
      swatch.getAttribute('data-product-handle'),
      swatch.getAttribute('data-pr-handle')
    );

    var parentWithProduct = swatch.closest('[data-product-handle], [data-pr-handle], [data-product-url], [data-pr-href], [data-href], [data-url], a[href*="/products/"]');
    if (parentWithProduct && parentWithProduct !== swatch) {
      candidates.push(
        getHandleFromHref(parentWithProduct.getAttribute('href')),
        getHandleFromHref(parentWithProduct.getAttribute('data-product-url')),
        getHandleFromHref(parentWithProduct.getAttribute('data-pr-href')),
        getHandleFromHref(parentWithProduct.getAttribute('data-href')),
        getHandleFromHref(parentWithProduct.getAttribute('data-url')),
        parentWithProduct.getAttribute('data-product-handle'),
        parentWithProduct.getAttribute('data-pr-handle')
      );
    }

    return candidates.filter(Boolean)[0] || '';
  }

  function productImageUrl(src, width) {
    if (!src) return '';

    if (window.Shopify && Shopify.Image && typeof Shopify.Image.getSizedImageUrl === 'function') {
      return Shopify.Image.getSizedImageUrl(src, width + 'x');
    }

    var parts = String(src).split('?');
    var base = parts[0];
    var query = parts[1] ? parts[1].split('&').filter(function(part) {
      return part.indexOf('width=') !== 0;
    }) : [];

    query.push('width=' + width);

    return base + '?' + query.join('&');
  }

  function productImageSrcset(src) {
    if (!src) return '';

    return [360, 540, 720, 900, 1100].map(function(width) {
      return productImageUrl(src, width) + ' ' + width + 'w';
    }).join(', ');
  }

  function getProductMediaImageSrc(media) {
    if (!media) return '';

    if (typeof media === 'string') return media;
    if (media.src) return media.src;
    if (media.preview_image && media.preview_image.src) return media.preview_image.src;
    if (media.image && media.image.src) return media.image.src;

    return '';
  }

  function getProductMediaPosterSrc(media) {
    if (!media) return '';

    if (media.preview_image && media.preview_image.src) return media.preview_image.src;
    if (media.image && media.image.src) return media.image.src;
    if (media.poster) return media.poster;

    return '';
  }

  function getProductMediaVideoSources(media) {
    if (!media) return [];

    var rawSources = media.sources || media.video_sources || [];

    return rawSources.map(function(source) {
      if (!source) return null;

      return {
        url: source.url || source.src || '',
        mimeType: source.mime_type || source.mimeType || source.type || ''
      };
    }).filter(function(source) {
      return source && source.url;
    });
  }

  function getPreferredVideoSource(sources) {
    sources = sources || [];

    return sources.find(function(source) {
      return /mp4/i.test(source.mimeType || source.url);
    }) || sources[0] || null;
  }

  function buildGalleryFromProduct(product) {
    if (!product) return [];

    var gallery = [];
    var media = product.media && product.media.length ? product.media : [];

    if (media.length) {
      media.forEach(function(item) {
        var type = item.media_type || item.type;

        if (type === 'image') {
          var src = getProductMediaImageSrc(item);
          if (!src) return;

          gallery.push({
            type: 'image',
            src: productImageUrl(src, 900),
            srcset: productImageSrcset(src),
            alt: item.alt || product.title || ''
          });
        } else if (type === 'video') {
          var videoSources = getProductMediaVideoSources(item);
          var preferredVideo = getPreferredVideoSource(videoSources);
          var poster = getProductMediaPosterSrc(item);

          gallery.push({
            type: 'video',
            src: preferredVideo ? preferredVideo.url : '',
            sources: videoSources,
            poster: poster ? productImageUrl(poster, 900) : '',
            posterSrcset: poster ? productImageSrcset(poster) : '',
            alt: item.alt || product.title || ''
          });
        } else if (type === 'external_video') {
          var externalPoster = getProductMediaPosterSrc(item);

          gallery.push({
            type: 'external_video',
            src: item.embed_url || item.external_id || '',
            poster: externalPoster ? productImageUrl(externalPoster, 900) : '',
            posterSrcset: externalPoster ? productImageSrcset(externalPoster) : '',
            alt: item.alt || product.title || ''
          });
        }
      });
    } else if (product.images && product.images.length) {
      product.images.forEach(function(src) {
        gallery.push({
          type: 'image',
          src: productImageUrl(src, 900),
          srcset: productImageSrcset(src),
          alt: product.title || ''
        });
      });
    }

    return gallery;
  }

  function fetchProductJson(handle) {
    if (!handle) return Promise.reject(new Error('Missing product handle'));
    if (productJsonCache[handle]) return productJsonCache[handle];

    productJsonCache[handle] = fetch('/products/' + handle + '.js', {
      headers: { 'Accept': 'application/json' },
      cache: 'force-cache'
    }).then(function(response) {
      if (!response.ok) throw new Error('Could not load product JSON for ' + handle);
      return response.json();
    });

    return productJsonCache[handle];
  }

  function prefetchProductGallery(handle) {
    if (!handle) return;

    fetchProductJson(handle).then(function(product) {
      buildGalleryFromProduct(product).forEach(function(item) {
        if (item.type === 'image') {
          preloadUrl(item.src, item.srcset);
        } else if (item.poster) {
          preloadUrl(item.poster, item.posterSrcset);
        }
      });
    }).catch(function() {});
  }

  function resetCardGalleryCache(card) {
    if (!card) return;

    card._ifGalleryImages = null;
    card._ifGalleryImagesJson = null;
    card.removeAttribute('data-if-gallery-preloaded');
  }

  function setCardGallery(card, gallery, renderFirstMedia) {
    if (!card || !gallery || !gallery.length) return;

    card.setAttribute('data-if-gallery-images', JSON.stringify(gallery));
    card.setAttribute('data-if-current-gallery-index', '0');
    resetCardGalleryCache(card);

    var nav = card.querySelector('[data-if-card-image-nav]');
    if (nav) {
      nav.setAttribute('data-if-current-index', '0');
      nav.style.display = gallery.length > 1 ? '' : 'none';
    }

    if (renderFirstMedia) {
      setCardImage(card, 0);
      card.setAttribute('data-if-gallery-rendered-handle', card.getAttribute('data-if-gallery-handle') || '');
      return;
    }

    preloadCardGallery(card, false);
  }

  function syncCardGalleryToCurrentProduct(card, fallbackHandle) {
    if (!card) return;

    var handle = fallbackHandle || getCurrentProductHandle(card);
    if (!handle) return;

    if (card.getAttribute('data-if-gallery-handle') === handle) {
      resetCardGalleryCache(card);
      if (fallbackHandle && card.getAttribute('data-if-gallery-rendered-handle') !== handle) {
        setCardImage(card, 0);
        card.setAttribute('data-if-gallery-rendered-handle', handle);
      }
      return;
    }

    fetchProductJson(handle).then(function(product) {
      var currentHandle = getCurrentProductHandle(card);
      var pendingHandle = card.getAttribute('data-if-pending-gallery-handle') || '';
      if (currentHandle && currentHandle !== handle && pendingHandle !== handle) return;

      var gallery = buildGalleryFromProduct(product);
      if (!gallery.length) return;

      card.setAttribute('data-if-gallery-handle', handle);
      if (pendingHandle === handle) card.removeAttribute('data-if-pending-gallery-handle');
      setCardGallery(card, gallery, !!fallbackHandle);
    }).catch(function() {});
  }

  function queueSwatchGallerySync(card, fallbackHandle) {
    if (!card) return;

    clearDynamicVideoForProductChange(card);

    if (fallbackHandle) {
      card.setAttribute('data-if-pending-gallery-handle', fallbackHandle);
      prefetchProductGallery(fallbackHandle);
    }

    [0, 80, 250, 700].forEach(function(delay) {
      setTimeout(function() {
        syncCardGalleryToCurrentProduct(card, fallbackHandle);
      }, delay);
    });
  }

  function warmSwatchGallery(swatch) {
    var handle = getSwatchProductHandle(swatch);
    if (!handle) return;

    prefetchProductGallery(handle);
  }

  function preloadCardGallery(card, preloadAll) {
    if (!card) return;

    var gallery = getCardGallery(card);
    if (!gallery.length) return;

    if (preloadAll) {
      if (card.getAttribute('data-if-gallery-preloaded') === 'true') return;
      card.setAttribute('data-if-gallery-preloaded', 'true');

      var currentIndex = parseInt(card.getAttribute('data-if-current-gallery-index') || '0', 10);
      if (isNaN(currentIndex)) currentIndex = 0;

      gallery.forEach(function(item, index) {
        if (index === currentIndex) return;
        if (item.type === 'image') {
          preloadUrl(item.src, item.srcset);
        } else if (item.poster) {
          preloadUrl(item.poster, item.posterSrcset);
        }
      });
      return;
    }

    var currentIndex = parseInt(card.getAttribute('data-if-current-gallery-index') || '0', 10);
    if (isNaN(currentIndex)) currentIndex = 0;
    var nextIndex = wrapGalleryIndex(currentIndex + 1, gallery.length);
    var prevIndex = currentIndex < 0 ? gallery.length - 1 : wrapGalleryIndex(currentIndex - 1, gallery.length);

    if (gallery[nextIndex] && gallery[nextIndex].type === 'image') {
      preloadUrl(gallery[nextIndex].src, gallery[nextIndex].srcset);
    } else if (gallery[nextIndex] && gallery[nextIndex].poster) {
      preloadUrl(gallery[nextIndex].poster, gallery[nextIndex].posterSrcset);
    }

    if (gallery[prevIndex] && gallery[prevIndex].type === 'image') {
      preloadUrl(gallery[prevIndex].src, gallery[prevIndex].srcset);
    } else if (gallery[prevIndex] && gallery[prevIndex].poster) {
      preloadUrl(gallery[prevIndex].poster, gallery[prevIndex].posterSrcset);
    }
  }

  function setCardImage(card, nextIndex) {
    var gallery = getCardGallery(card);
    if (!gallery.length) return;

    var image = getMainImage(card) || createMainImage(card);
    if (!image) return;

    var index = wrapGalleryIndex(nextIndex, gallery.length);
    var item = gallery[index];
    if (!item) return;

    if (item.type === 'video' || item.type === 'external_video') {
      showVideoMedia(card, item);
      card.setAttribute('data-if-current-gallery-index', String(index));

      var videoNav = card.querySelector('[data-if-card-image-nav]');
      if (videoNav) videoNav.setAttribute('data-if-current-index', String(index));

      preloadCardGallery(card, false);
      return;
    }

    if (!item.src) return;

    removeDynamicVideo(card);

    var picture = image.closest('picture');
    if (picture && item.srcset) {
      picture.querySelectorAll('source').forEach(function(source) {
        source.setAttribute('srcset', item.srcset);
        source.setAttribute('data-srcset', item.srcset);
      });
    }

    if (item.srcset) {
      image.setAttribute('srcset', item.srcset);
      image.setAttribute('data-srcset', item.srcset);
    }

    image.setAttribute('src', item.src);
    image.setAttribute('data-src', item.src);
    image.setAttribute('data-master', item.src);

    if (item.alt) image.setAttribute('alt', item.alt);

    showImageMedia(card, image);

    card.setAttribute('data-if-current-gallery-index', String(index));

    var nav = card.querySelector('[data-if-card-image-nav]');
    if (nav) nav.setAttribute('data-if-current-index', String(index));

    preloadCardGallery(card, false);
  }

  document.addEventListener('pointerover', function(event) {
    var card = event.target && event.target.closest ? event.target.closest('.if-card-image-arrows-enabled[data-if-gallery-images]') : null;
    if (!card) return;

    preloadCardGallery(card, true);
  }, true);

  if ('requestIdleCallback' in window) {
    requestIdleCallback(function() {
      document.querySelectorAll('.if-card-image-arrows-enabled[data-if-gallery-images]').forEach(function(card) {
        preloadCardGallery(card, false);
      });
    }, { timeout: 1800 });
  } else {
    setTimeout(function() {
      document.querySelectorAll('.if-card-image-arrows-enabled[data-if-gallery-images]').forEach(function(card) {
        preloadCardGallery(card, false);
      });
    }, 1200);
  }

  document.addEventListener('pointerover', function(event) {
    var swatch = event.target && event.target.closest ? event.target.closest('.t4s-product-colors .t4s-pr-color__item, .t4s-product-colors [data-handle], .t4s-product-colors [data-product-handle]') : null;
    if (!swatch) return;

    warmSwatchGallery(swatch);
  }, true);

  document.addEventListener('pointerdown', function(event) {
    var swatch = event.target && event.target.closest ? event.target.closest('.t4s-product-colors .t4s-pr-color__item, .t4s-product-colors [data-handle], .t4s-product-colors [data-product-handle]') : null;
    if (!swatch) return;

    var card = swatch.closest('.if-card-image-arrows-enabled');
    if (card) clearDynamicVideoForProductChange(card);

    warmSwatchGallery(swatch);
  }, true);

  document.addEventListener('focusin', function(event) {
    var swatch = event.target && event.target.closest ? event.target.closest('.t4s-product-colors .t4s-pr-color__item, .t4s-product-colors [data-handle], .t4s-product-colors [data-product-handle]') : null;
    if (!swatch) return;

    warmSwatchGallery(swatch);
  }, true);

  document.addEventListener('click', function(event) {
    var swatch = event.target && event.target.closest ? event.target.closest('.t4s-product-colors .t4s-pr-color__item, .t4s-product-colors [data-handle], .t4s-product-colors [data-product-handle]') : null;
    if (!swatch) return;

    var card = swatch.closest('.if-card-image-arrows-enabled');
    if (!card) return;

    queueSwatchGallerySync(card, getSwatchProductHandle(swatch));
  }, true);

  document.addEventListener('click', function(event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-if-card-image-prev], [data-if-card-image-next]') : null;
    if (!button) return;

    var card = button.closest('.if-card-image-arrows-enabled[data-if-gallery-images]');
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    var currentIndex = parseInt(card.getAttribute('data-if-current-gallery-index') || '0', 10);
    if (isNaN(currentIndex)) currentIndex = 0;
    var direction = button.hasAttribute('data-if-card-image-prev') ? -1 : 1;
    var activeHandle = card.getAttribute('data-if-pending-gallery-handle') || getCurrentProductHandle(card);

    if (activeHandle && card.getAttribute('data-if-gallery-handle') !== activeHandle) {
      fetchProductJson(activeHandle).then(function(product) {
        var currentHandle = getCurrentProductHandle(card);
        var pendingHandle = card.getAttribute('data-if-pending-gallery-handle') || '';
        if (currentHandle && currentHandle !== activeHandle && pendingHandle !== activeHandle) return;

        var freshGallery = buildGalleryFromProduct(product);
        if (!freshGallery.length) return;

        card.setAttribute('data-if-gallery-handle', activeHandle);
        if (pendingHandle === activeHandle) card.removeAttribute('data-if-pending-gallery-handle');
        setCardGallery(card, freshGallery);
        setCardImage(card, direction);
      }).catch(function() {});

      return;
    }

    var gallery = getCardGallery(card);
    if (gallery.length < 2) return;

    var nextIndex = currentIndex + direction;

    setCardImage(card, nextIndex);
  }, true);
})();

;

(function(){
  if(window._t4sQuickAddReady) return;
  window._t4sQuickAddReady = true;

  function init(){
    var tip = document.createElement('div');
    tip.style.cssText = 'position:fixed;background:#333;color:#fff;padding:5px 10px;border-radius:4px;font-size:11px;line-height:1.4;z-index:99999;pointer-events:none;opacity:0;transform:translateY(5px);transition:opacity 0.2s ease,transform 0.2s ease;white-space:pre-line;text-align:center;box-shadow:0 4px 6px rgba(0,0,0,0.1);';
    document.body.appendChild(tip);

    var arrow = document.createElement('div');
    arrow.style.cssText = 'position:fixed;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid #333;z-index:99999;pointer-events:none;opacity:0;transform:translateY(5px);transition:opacity 0.2s ease,transform 0.2s ease;';
    document.body.appendChild(arrow);

    var currentSwatch = null;

    function hideTip(){
      currentSwatch = null;
      tip.style.opacity = '0';
      tip.style.transform = 'translateY(5px)';
      arrow.style.opacity = '0';
      arrow.style.transform = 'translateY(5px)';
    }

    function showTip(swatch){
      if(swatch === currentSwatch) return;
      currentSwatch = swatch;

      if(!tip.parentElement) document.body.appendChild(tip);
      if(!arrow.parentElement) document.body.appendChild(arrow);

      tip.textContent = swatch.getAttribute('data-size-bestfit');

      var r = swatch.getBoundingClientRect();
      tip.style.left = Math.max(0, r.left + r.width / 2 - tip.offsetWidth / 2) + 'px';
      tip.style.top = (r.top - tip.offsetHeight - 8) + 'px';
      arrow.style.left = (r.left + r.width / 2 - 5) + 'px';
      arrow.style.top = (r.top - 8) + 'px';

      tip.style.opacity = '1';
      tip.style.transform = 'translateY(0)';
      arrow.style.opacity = '1';
      arrow.style.transform = 'translateY(0)';
    }

    function applyData(buttons, sizes){
      buttons.forEach(function(btn){
        var sizeName = (btn.getAttribute('data-if-size-value') || btn.textContent || '').trim();
        var info = sizes && sizes[sizeName];

        if(!info) return;

        /*
          Do not let generic best-fit data re-enable a size that Liquid has already
          disabled by the current Shopify availability state. A button can only be
          re-enabled when the swatch/PDP sync below sends bufferedAvailable:true.
        */
        var hasBufferedState = typeof info.bufferedAvailable !== 'undefined';
        var currentlyEnabled = !btn.classList.contains('is--unavailable') && !btn.hasAttribute('disabled');
        var isAvailable = hasBufferedState ? info.bufferedAvailable === true : (currentlyEnabled && info.available === true);

        btn.classList.remove('is--buffer-checking');
        btn.setAttribute('data-if-buffered-available', isAvailable ? 'true' : 'false');

        if(isAvailable){
          btn.classList.remove('is--unavailable');
          btn.removeAttribute('disabled');

          if(info.variantId) {
            btn.setAttribute('data-variant-id', info.variantId);
            btn.setAttribute('data-if-original-variant-id', info.variantId);
          } else if(btn.getAttribute('data-if-original-variant-id')) {
            btn.setAttribute('data-variant-id', btn.getAttribute('data-if-original-variant-id'));
          }

          if(info.bestfit){
            btn.setAttribute('data-size-bestfit', 'Best fit: ' + info.bestfit);
          } else {
            btn.setAttribute('data-size-bestfit', '');
          }
        } else {
          btn.classList.add('is--unavailable');
          btn.setAttribute('disabled', '');
          btn.removeAttribute('data-variant-id');

          var tipText = 'Sold out';
          if(info.bestfit) tipText += '\nBest fit: ' + info.bestfit;

          btn.setAttribute('data-size-bestfit', tipText);
        }
      });
    }

    var quickAddBufferCache = {};
    var quickAddKnownStateByHandle = {};
    var quickAddSyncTimers = new WeakMap();

    function ifSafeJsonParse(value){
      try {
        return JSON.parse(value || '{}');
      } catch(e) {
        return {};
      }
    }

    function ifNormalizeStateForButtons(rawSizes, sizeNames){
      var normalized = {};
      var raw = rawSizes || {};

      Object.keys(raw).forEach(function(sizeName){
        normalized[ifNormalizeSize(sizeName)] = raw[sizeName];
      });

      var state = {};

      (sizeNames || []).forEach(function(sizeName){
        var info = raw[sizeName] || normalized[ifNormalizeSize(sizeName)];
        if(!info) return;

        state[sizeName] = {
          available: info.bufferedAvailable === true,
          bufferedAvailable: info.bufferedAvailable === true,
          variantId: info.bufferedAvailable === true ? (info.variantId || '') : '',
          bestfit: info.bestfit || ''
        };
      });

      return Object.keys(state).length ? state : null;
    }

    function ifReadEmbeddedQuickAddState(card){
      if(!card) return null;

      var holder = card.querySelector('[data-if-quickadd-buffer-state]');
      if(!holder) return null;

      var state = ifSafeJsonParse(holder.textContent || holder.innerHTML || '{}');
      if(!state || !state.handle || !state.sizes) return null;

      return state;
    }

    function ifRegisterQuickAddState(card){
      var state = ifReadEmbeddedQuickAddState(card);
      if(!state || !state.handle || !state.sizes) return null;

      quickAddKnownStateByHandle[state.handle] = state.sizes;
      card.setAttribute('data-if-quickadd-buffer-source-handle', state.handle);

      return state;
    }

    function ifRegisterAllQuickAddStates(root){
      (root || document).querySelectorAll('.t4s-product').forEach(function(card){
        ifRegisterQuickAddState(card);
      });
    }

    function ifGetKnownBufferedState(card, handle, sizeNames){
      if(!handle) return null;

      var embedded = ifRegisterQuickAddState(card);
      if(embedded && embedded.handle === handle) {
        return ifNormalizeStateForButtons(embedded.sizes, sizeNames);
      }

      if(!quickAddKnownStateByHandle[handle]) {
        ifRegisterAllQuickAddStates(document);
      }

      if(quickAddKnownStateByHandle[handle]) {
        return ifNormalizeStateForButtons(quickAddKnownStateByHandle[handle], sizeNames);
      }

      return null;
    }

    function ifHandleFromHref(href){
      if(!href) return '';
      var match = String(href).match(/\/products\/([^?#\/]+)/);
      return match ? match[1] : '';
    }

    function ifGetSwatchHandle(swatch){
      if(!swatch) return '';

      /* Do not trust generic data-handle on colour swatches; it can be only the colour value. */
      var candidates = [];

      var link = swatch.closest('a[href*="/products/"]') || (swatch.querySelector && swatch.querySelector('a[href*="/products/"]'));
      if(link) candidates.push(ifHandleFromHref(link.getAttribute('href')));

      candidates.push(
        ifHandleFromHref(swatch.getAttribute('href')),
        ifHandleFromHref(swatch.getAttribute('data-href')),
        ifHandleFromHref(swatch.getAttribute('data-url')),
        ifHandleFromHref(swatch.getAttribute('data-pr-href')),
        ifHandleFromHref(swatch.getAttribute('data-product-url')),
        swatch.getAttribute('data-product-handle'),
        swatch.getAttribute('data-pr-handle')
      );

      var parentWithProduct = swatch.closest('[data-product-handle], [data-pr-handle], [data-product-url], [data-pr-href], [data-href], [data-url], a[href*="/products/"]');
      if(parentWithProduct && parentWithProduct !== swatch){
        candidates.push(
          ifHandleFromHref(parentWithProduct.getAttribute('href')),
          ifHandleFromHref(parentWithProduct.getAttribute('data-product-url')),
          ifHandleFromHref(parentWithProduct.getAttribute('data-pr-href')),
          ifHandleFromHref(parentWithProduct.getAttribute('data-href')),
          ifHandleFromHref(parentWithProduct.getAttribute('data-url')),
          parentWithProduct.getAttribute('data-product-handle'),
          parentWithProduct.getAttribute('data-pr-handle')
        );
      }

      return candidates.filter(Boolean)[0] || '';
    }

    function ifGetCurrentProductHandle(card){
      if(!card) return '';

      var pendingHandle = card.getAttribute('data-if-pending-quickadd-handle') || card.getAttribute('data-if-pending-badge-handle') || '';
      if(pendingHandle) return pendingHandle;

      var selectedLink = card.querySelector('.t4s-product-title a[href*="/products/"]') ||
        card.querySelector('a[data-pr-href][href*="/products/"]') ||
        card.querySelector('.t4s-full-width-link[href*="/products/"]') ||
        card.querySelector('a[href*="/products/"]');

      return selectedLink ? ifHandleFromHref(selectedLink.getAttribute('href')) : '';
    }

    function ifNormalizeSize(value){
      return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
    }

    function ifButtonSizeNames(buttons){
      return Array.prototype.map.call(buttons || [], function(btn){
        return (btn.getAttribute('data-if-size-value') || btn.textContent || '').trim();
      }).filter(Boolean);
    }

    function ifFetchProductJson(handle){
      return fetch('/products/' + handle + '.js', {
        headers: { 'Accept': 'application/json' },
        cache: 'force-cache'
      }).then(function(response){
        if(!response.ok) throw new Error('Could not load product JSON');
        return response.json();
      });
    }

    function ifFetchProductHtml(handle){
      return fetch('/products/' + handle, {
        headers: { 'Accept': 'text/html' },
        cache: 'force-cache'
      }).then(function(response){
        if(!response.ok) throw new Error('Could not load product page');
        return response.text();
      });
    }

    function ifFindSizeOptionIndex(product){
      var options = product && product.options ? product.options : [];
      var index = -1;

      options.forEach(function(option, i){
        var optionName = typeof option === 'string' ? option : option && option.name;
        if(index === -1 && /size/i.test(String(optionName || ''))) index = i;
      });

      return index === -1 ? 0 : index;
    }

    function ifVariantsBySize(product){
      var map = {};
      var sizeIndex = ifFindSizeOptionIndex(product);
      var optionKey = 'option' + (sizeIndex + 1);

      (product && product.variants || []).forEach(function(variant){
        var size = variant[optionKey] || variant.option1 || variant.title || '';
        if(!size) return;

        var key = ifNormalizeSize(size);
        if(!map[key] || variant.available) map[key] = variant;
      });

      return map;
    }

    function ifLooksSoldOut(el){
      if(!el) return false;

      var node = el;
      var depth = 0;

      while(node && depth < 4){
        if(node.disabled || node.getAttribute('disabled') !== null) return true;
        if(node.getAttribute('aria-disabled') === 'true') return true;
        if(node.getAttribute('data-disabled') === 'true') return true;
        if(node.getAttribute('data-available') === 'false') return true;

        var cls = String(node.className || '').toLowerCase();
        if(/sold|unavailable|disabled|is--soldout|is-soldout|is--disabled|is-disabled/.test(cls)) return true;

        var txt = ifNormalizeSize(node.textContent || '');
        if(txt.indexOf('sold out') > -1 || txt.indexOf('unavailable') > -1) return true;

        node = node.parentElement;
        depth += 1;
      }

      return false;
    }

    function ifFindPdpSizeAvailability(doc, sizeName){
      var wanted = ifNormalizeSize(sizeName);
      if(!doc || !wanted) return null;

      var selectors = [
        'button',
        'label',
        'option',
        '[role="button"]',
        '[data-value]',
        '[data-option-value]',
        '[data-variant-value]',
        '.t4s-swatch__item',
        '.t4s-swatch__value',
        '.t4s-swatch__label'
      ].join(',');

      var matches = Array.prototype.slice.call(doc.querySelectorAll(selectors)).filter(function(el){
        var values = [
          el.getAttribute('data-value'),
          el.getAttribute('data-option-value'),
          el.getAttribute('data-variant-value'),
          el.getAttribute('value'),
          el.getAttribute('title'),
          el.getAttribute('aria-label'),
          el.textContent
        ].map(ifNormalizeSize).filter(Boolean);

        return values.indexOf(wanted) > -1;
      });

      if(!matches.length) return null;

      return matches.some(function(el){
        return !ifLooksSoldOut(el);
      });
    }

    function ifBuildBufferedState(handle, sizeNames){
      var cacheKey = handle + '::' + (sizeNames || []).join('|');
      if(quickAddBufferCache[cacheKey]) return quickAddBufferCache[cacheKey];

      /*
        IMPORTANT:
        For dynamically-rendered/switched products, use Shopify's product JSON as the
        source of truth for variant availability. The previous version also scraped
        the PDP HTML and required ifFindPdpSizeAvailability() to return true. On Kalles,
        the fetched PDP markup can contain hidden/disabled swatch markup, which caused
        every freshly-rendered Quick Add size to be marked Sold out even when the
        variant itself was available.
      */
      quickAddBufferCache[cacheKey] = ifFetchProductJson(handle).then(function(product){
        var variantsBySize = ifVariantsBySize(product);
        var state = {};

        (sizeNames || []).forEach(function(sizeName){
          var variant = variantsBySize[ifNormalizeSize(sizeName)];
          var isAvailable = !!(variant && variant.available === true);

          state[sizeName] = {
            available: isAvailable,
            bufferedAvailable: isAvailable,
            variantId: isAvailable ? variant.id : '',
            bestfit: ''
          };
        });

        return state;
      });

      return quickAddBufferCache[cacheKey];
    }

    function ifMarkButtonsChecking(buttons){
      buttons.forEach(function(btn){
        btn.classList.add('is--buffer-checking');
        btn.classList.add('is--unavailable');
        btn.setAttribute('disabled', '');
        btn.removeAttribute('data-variant-id');
        btn.setAttribute('data-if-buffered-available', 'false');
      });
    }

    function ifSyncQuickAddBuffer(card, handle){
      if(!card || !handle) return;

      var buttons = Array.prototype.slice.call(card.querySelectorAll('.t4s-size-overlay-item'));
      if(!buttons.length) return;

      var sizeNames = ifButtonSizeNames(buttons);
      if(!sizeNames.length) return;

      var knownState = ifGetKnownBufferedState(card, handle, sizeNames);
      if(knownState) {
        if(card.getAttribute('data-if-quickadd-buffer-handle') !== handle) card.setAttribute('data-if-quickadd-buffer-handle', handle);
        applyData(buttons, knownState);
        card.setAttribute('data-if-quickadd-buffer-complete', handle);
        return;
      }

      if(card.getAttribute('data-if-quickadd-buffer-handle') !== handle) card.setAttribute('data-if-quickadd-buffer-handle', handle);
      ifMarkButtonsChecking(buttons);

      ifBuildBufferedState(handle, sizeNames).then(function(state){
        if(card.getAttribute('data-if-quickadd-buffer-handle') !== handle) return;
        applyData(buttons, state);
        card.setAttribute('data-if-quickadd-buffer-complete', handle);
      }).catch(function(){
        /* Keep the buttons disabled rather than risking overselling buffered stock. */
      });
    }

    function ifQueueQuickAddBufferSync(card, handle, delay){
      if(!card) return;

      clearTimeout(quickAddSyncTimers.get(card));

      quickAddSyncTimers.set(card, setTimeout(function(){
        if(!card || !card.querySelector || !card.querySelector('.t4s-size-overlay-item')) return;

        ifRegisterQuickAddState(card);

        var liveHandle = handle || ifGetCurrentProductHandle(card) || card.getAttribute('data-if-quickadd-buffer-handle') || card.getAttribute('data-if-quickadd-buffer-source-handle') || '';
        if(liveHandle) ifSyncQuickAddBuffer(card, liveHandle);
      }, delay || 80));
    }

    function ifSyncQuickAddBuffersIn(root, forcedHandle){
      ifRegisterAllQuickAddStates(root || document);

      (root || document).querySelectorAll('.t4s-product').forEach(function(card){
        if(!card.querySelector('.t4s-size-overlay-item')) return;

        var handle = forcedHandle || ifGetCurrentProductHandle(card) || card.getAttribute('data-if-quickadd-buffer-handle') || '';
        if(handle) ifQueueQuickAddBufferSync(card, handle, 40);
      });
    }

    function ifFindCardByHandle(handle){
      if(!handle) return null;

      var link = document.querySelector('.t4s-product .t4s-product-title a[href*="/products/' + handle + '"]') ||
        document.querySelector('.t4s-product a[data-pr-href][href*="/products/' + handle + '"]') ||
        document.querySelector('.t4s-product .t4s-full-width-link[href*="/products/' + handle + '"]');

      return link ? link.closest('.t4s-product') : null;
    }

    document.addEventListener('click', function(e){
      var swatch = e.target && e.target.closest ? e.target.closest('.t4s-product-colors .t4s-pr-color__item, .t4s-product-colors [data-handle], .t4s-product-colors [data-product-handle]') : null;
      if(!swatch) return;

      var card = swatch.closest('.t4s-product');
      if(!card) return;

      var swatchHandle = ifGetSwatchHandle(swatch);

      if(swatchHandle) {
        card.setAttribute('data-if-pending-quickadd-handle', swatchHandle);
      } else {
        card.removeAttribute('data-if-pending-quickadd-handle');
      }

      [0, 80, 180, 350, 700, 1200, 2000].forEach(function(delay){
        setTimeout(function(){
          ifRegisterAllQuickAddStates(document);

          var liveCard = card && card.isConnected ? card : ifFindCardByHandle(swatchHandle);
          if(liveCard) {
            var liveHandle = swatchHandle || ifGetCurrentProductHandle(liveCard);
            if(liveHandle) ifSyncQuickAddBuffer(liveCard, liveHandle);
          }

          /* Kalles can replace or mutate the entire product card after the swatch click.
             Re-scan visible cards so the newly-rendered quick add buttons get the buffer too. */
          ifSyncQuickAddBuffersIn(document);
        }, delay);
      });

      setTimeout(function(){
        if(card && swatchHandle && card.getAttribute('data-if-pending-quickadd-handle') === swatchHandle) {
          card.removeAttribute('data-if-pending-quickadd-handle');
        }
      }, 2600);
    }, true);

    document.addEventListener('pointerover', function(e){
      var card = e.target && e.target.closest ? e.target.closest('.t4s-product') : null;
      if(!card || !card.querySelector('.t4s-size-overlay-item')) return;

      ifQueueQuickAddBufferSync(card, ifGetCurrentProductHandle(card), 40);
    }, true);

    function ifInitialQuickAddBufferSync(){
      ifSyncQuickAddBuffersIn(document);
    }

    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', ifInitialQuickAddBufferSync);
    } else {
      setTimeout(ifInitialQuickAddBufferSync, 120);
    }

    document.addEventListener('t4s:collection-badge:updated', function(e){
      if(!e || !e.detail || !e.detail.card) return;
      ifQueueQuickAddBufferSync(e.detail.card, e.detail.handle || '', 30);
    });

    if(window.MutationObserver){
      var quickAddObserver = new MutationObserver(function(mutations){
        var cards = [];

        mutations.forEach(function(mutation){
          if(mutation.type === 'attributes'){
            var attrCard = mutation.target && mutation.target.closest ? mutation.target.closest('.t4s-product') : null;
            if(attrCard && cards.indexOf(attrCard) === -1) cards.push(attrCard);
            return;
          }

          Array.prototype.forEach.call(mutation.addedNodes || [], function(node){
            if(!node || node.nodeType !== 1) return;

            if(node.matches && node.matches('.t4s-product')){
              if(cards.indexOf(node) === -1) cards.push(node);
            }

            if(node.querySelectorAll){
              node.querySelectorAll('.t4s-product').forEach(function(card){
                if(cards.indexOf(card) === -1) cards.push(card);
              });
            }

            var ownCard = node.closest && node.closest('.t4s-product');
            if(ownCard && cards.indexOf(ownCard) === -1) cards.push(ownCard);
          });
        });

        cards.forEach(function(card){
          ifQueueQuickAddBufferSync(card, '', 80);
        });
      });

      if(document.body){
        quickAddObserver.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['href', 'data-product-options']
        });
      }
    }

    document.addEventListener('mousemove', function(e){
      var el = e.target;
      if(el && el.nodeType === 3) el = el.parentElement;
      if(!el || !el.closest) return;

      var btn = el.closest('.t4s-size-overlay-item');

      if(btn){
        if(!btn.hasAttribute('data-size-bestfit')){
          var card = btn.closest('.t4s-product');

          if(card){
            var link = card.querySelector('a[href*="/products/"]');

            if(link){
              var m = link.getAttribute('href').match(/\/products\/([^?#\/]+)/);

              if(m && window._t4sBestfit && window._t4sBestfit[m[1]]){
                applyData(card.querySelectorAll('.t4s-size-overlay-item'), window._t4sBestfit[m[1]]);
              }
            }
          }
        }

        var val = btn.getAttribute('data-size-bestfit');

        if(val && val !== ''){
          showTip(btn);
        } else if(currentSwatch){
          hideTip();
        }
      } else if(currentSwatch){
        hideTip();
      }
    });

    function refreshCart(data){
      function renderSections(sections){
        if(!sections) return;

        if(sections.mini_cart){
          var doc = new DOMParser().parseFromString(sections.mini_cart, 'text/html');
          var freshSection = doc.querySelector('#shopify-section-mini_cart');
          var currentSection = document.querySelector('#shopify-section-mini_cart');
          var freshCart = doc.querySelector('#t4s-mini_cart');
          var currentCart = document.querySelector('#t4s-mini_cart');

          if(freshSection && currentSection){
            currentSection.innerHTML = freshSection.innerHTML;
          } else if(freshCart && currentCart){
            currentCart.outerHTML = freshCart.outerHTML;
          }
        }

        if(sections.cart_data){
          var raw = sections.cart_data;
          var match = raw.match(/\[t4s_split1\]([\s\S]*?)\[t4s_split1\]/);

          if(match){
            var parts = match[1].split('[t4s_split2]');
            var count = parts[0] || '0';
            var priceHtml = parts[1] || '';

            document.querySelectorAll('[data-cart-count]').forEach(function(el){
              el.textContent = count;

              if(parseInt(count, 10) > 0) {
                el.classList.remove('t4s-op-0');
              } else {
                el.classList.add('t4s-op-0');
              }
            });

            document.querySelectorAll('[data-cart-tt-price]').forEach(function(el){
              el.innerHTML = priceHtml;
            });
          }
        }

        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('t4s:cart:updated', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }

      if(data && data.sections){
        renderSections(data.sections);
        return Promise.resolve();
      }

      return fetch('/cart?sections=mini_cart,cart_data&_=' + Date.now(), {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        cache: 'no-store'
      })
      .then(function(r){ return r.json(); })
      .then(function(sections){ renderSections(sections); });
    }

    document.addEventListener('click', function(e){
      var el = e.target;
      if(el && el.nodeType === 3) el = el.parentElement;
      if(!el || !el.closest) return;

      var btn = el.closest('.t4s-size-overlay-item[data-variant-id]');

      if(
        !btn ||
        btn.classList.contains('is--unavailable') ||
        btn.classList.contains('is--adding') ||
        btn.classList.contains('is--added')
      ) return;

      e.preventDefault();
      e.stopPropagation();

      hideTip();

      var variantId = btn.getAttribute('data-variant-id');
      var origText = btn.textContent;

      btn.classList.add('is--adding');
      btn.innerHTML = '<span class="t4s-size-spinner"></span>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: parseInt(variantId, 10),
              quantity: 1
            }
          ],
          sections: 'cart_data,mini_cart',
          sections_url: window.location.pathname
        })
      })
      .then(function(res){
        if(!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function(data){
        btn.classList.remove('is--adding');
        btn.classList.add('is--added');
        btn.textContent = '\u2713';

        refreshCart(data);

        setTimeout(function(){
          var cartLink = document.querySelector('.t4s-site-nav__cart a[data-drawer-options]');
          if(cartLink) cartLink.click();
        }, 100);

        setTimeout(function(){
          btn.classList.remove('is--added');
          btn.textContent = origText;
        }, 1500);
      })
      .catch(function(){
        btn.classList.remove('is--adding');
        btn.textContent = origText;
      });
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

;

(function(){
  if (window._t4sDynamicCollectionBadgesReady) return;
  window._t4sDynamicCollectionBadgesReady = true;

  var productCache = {};
  var collectionProductsCache = {};
  var collectionMembershipCache = {};
  var pendingCards = new WeakMap();
  var badgeRequestCounter = 0;

  function safeJsonParse(value) {
    try {
      return JSON.parse(value || '{}');
    } catch (e) {
      return {};
    }
  }

  function createBadgeRequest(card, handle) {
    if (!card) return '';

    badgeRequestCounter += 1;

    var token = String(Date.now()) + '-' + String(badgeRequestCounter);

    card.setAttribute('data-if-badge-request-token', token);
    card.setAttribute('data-if-badge-request-handle', handle || '');

    return token;
  }

  function badgeRequestIsCurrent(card, token) {
    if (!token) return true;
    return !!card && card.getAttribute('data-if-badge-request-token') === token;
  }

  function handleize(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getHandleFromHref(href) {
    if (!href) return '';

    var match = String(href).match(/\/products\/([^?#\/]+)/);
    return match ? match[1] : '';
  }

  function getSwatchProductHandle(swatch) {
    if (!swatch) return '';

    /*
      Important: in Kalles colour swatches, generic data-handle can be the colour handle
      only, for example "positano-blue", not the actual product handle. If we use that
      as the product handle, /products/positano-blue.js fails and the secondary badge
      stays hidden after switching away and back.

      So we only trust real product URLs or product-specific attributes first.
      Generic data-handle is intentionally ignored here unless it is supplied through
      a product URL attribute that contains /products/.
    */
    var candidates = [];

    var link = swatch.closest('a[href*="/products/"]') || (swatch.querySelector && swatch.querySelector('a[href*="/products/"]'));
    if (link) candidates.push(getHandleFromHref(link.getAttribute('href')));

    candidates.push(
      getHandleFromHref(swatch.getAttribute('href')),
      getHandleFromHref(swatch.getAttribute('data-href')),
      getHandleFromHref(swatch.getAttribute('data-url')),
      getHandleFromHref(swatch.getAttribute('data-pr-href')),
      getHandleFromHref(swatch.getAttribute('data-product-url')),
      swatch.getAttribute('data-product-handle'),
      swatch.getAttribute('data-pr-handle')
    );

    var parentWithProduct = swatch.closest('[data-product-handle], [data-pr-handle], [data-product-url], [data-pr-href], [data-href], [data-url], a[href*="/products/"]');
    if (parentWithProduct && parentWithProduct !== swatch) {
      candidates.push(
        getHandleFromHref(parentWithProduct.getAttribute('href')),
        getHandleFromHref(parentWithProduct.getAttribute('data-product-url')),
        getHandleFromHref(parentWithProduct.getAttribute('data-pr-href')),
        getHandleFromHref(parentWithProduct.getAttribute('data-href')),
        getHandleFromHref(parentWithProduct.getAttribute('data-url')),
        parentWithProduct.getAttribute('data-product-handle'),
        parentWithProduct.getAttribute('data-pr-handle')
      );
    }

    return candidates.filter(Boolean)[0] || '';
  }

  function getLinkProductHandle(card) {
    if (!card) return '';

    var selectedLink =
      card.querySelector('.t4s-product-title a[href*="/products/"]') ||
      card.querySelector('a[data-pr-href][href*="/products/"]') ||
      card.querySelector('.t4s-full-width-link[href*="/products/"]') ||
      card.querySelector('a[href*="/products/"]');

    return selectedLink ? getHandleFromHref(selectedLink.getAttribute('href')) : '';
  }

  function getActiveSwatchHandle(card) {
    if (!card) return '';

    var activeSwatch = card.querySelector(
      '.t4s-product-colors .t4s-pr-color__item.is--active, ' +
      '.t4s-product-colors .t4s-pr-color__item.is-active, ' +
      '.t4s-product-colors .t4s-pr-color__item.is--selected, ' +
      '.t4s-product-colors .t4s-pr-color__item.is-selected, ' +
      '.t4s-product-colors .t4s-pr-color__item.active, ' +
      '.t4s-product-colors [aria-selected="true"], ' +
      '.t4s-product-colors [data-selected="true"]'
    );

    return getSwatchProductHandle(activeSwatch);
  }

  function getCurrentHandle(card) {
    if (!card) return '';

    /*
      Only use the pending swatch handle during the short re-render window.
      Do not keep a permanent active handle on the card, because that can become stale
      after switching colours away and back.
    */
    var pendingHandle = card.getAttribute('data-if-pending-badge-handle') || '';
    if (pendingHandle) return pendingHandle;

    return getActiveSwatchHandle(card) || getLinkProductHandle(card);
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.reject(new Error('Missing product handle'));
    if (productCache[handle]) return productCache[handle];

    productCache[handle] = fetch('/products/' + handle + '.js', {
      headers: { 'Accept': 'application/json' },
      cache: 'force-cache'
    }).then(function(response) {
      if (!response.ok) throw new Error('Could not load product JSON for ' + handle);
      return response.json();
    });

    return productCache[handle];
  }

  function getCollectionProductHandles(collectionHandle, page) {
    page = page || 1;

    var cacheKey = collectionHandle + '::page::' + page;
    if (collectionProductsCache[cacheKey]) return collectionProductsCache[cacheKey];

    collectionProductsCache[cacheKey] = fetch('/collections/' + collectionHandle + '/products.json?limit=250&page=' + page, {
      headers: { 'Accept': 'application/json' },
      cache: 'force-cache'
    }).then(function(response) {
      if (!response.ok) return [];
      return response.json();
    }).then(function(data) {
      return (data && data.products ? data.products : []).map(function(product) {
        return product.handle;
      }).filter(Boolean);
    }).catch(function() {
      return [];
    });

    return collectionProductsCache[cacheKey];
  }

  function productMatchesCollection(productHandle, collectionHandle) {
    if (!productHandle || !collectionHandle) return Promise.resolve(false);

    var key = collectionHandle + '::' + productHandle;
    if (collectionMembershipCache[key]) return collectionMembershipCache[key];

    /*
      Do not use /collections/{collection}/products/{product}.js for membership.
      Shopify can redirect or still resolve a product there, which makes every product
      look like it belongs to the collection. Instead, scan the collection products JSON.
    */
    collectionMembershipCache[key] = getCollectionProductHandles(collectionHandle, 1).then(function(handles) {
      if (handles.indexOf(productHandle) > -1) return true;

      if (handles.length < 250) return false;

      return getCollectionProductHandles(collectionHandle, 2).then(function(pageTwoHandles) {
        if (pageTwoHandles.indexOf(productHandle) > -1) return true;
        if (pageTwoHandles.length < 250) return false;

        return getCollectionProductHandles(collectionHandle, 3).then(function(pageThreeHandles) {
          return pageThreeHandles.indexOf(productHandle) > -1;
        });
      });
    }).catch(function() {
      return false;
    });

    return collectionMembershipCache[key];
  }

  function getFirstVariant(product) {
    return product && product.variants && product.variants.length ? product.variants[0] : {};
  }

  function getSalePercentOff(product) {
    var saleVariant = (product && product.variants || []).find(function(variant) {
      return Number(variant.compare_at_price || 0) > Number(variant.price || 0);
    });

    if (!saleVariant) return '';

    var compareAtPrice = Number(saleVariant.compare_at_price || 0);
    var price = Number(saleVariant.price || 0);

    if (!compareAtPrice || compareAtPrice <= price) return '';

    var percentOff = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);

    return percentOff + '% off';
  }

  function productIsNew(product, badgeEl) {
    var createdAt = product && product.created_at ? Date.parse(product.created_at) : NaN;
    if (!createdAt) return false;

    var card = badgeEl.closest('.t4s-product');
    var days = Number((card && card.getAttribute('data-dynamic-new-days')) || badgeEl.getAttribute('data-new-days') || 10);

    if (!days || days <= 0) return false;

    return ((Date.now() - createdAt) / 86400000) <= days;
  }

  function productIsPreorder(product) {
    if (!product) return false;

    var tags = (product.tags || []).join(',').toLowerCase();

    if (
      tags.indexOf('ispreoder') > -1 ||
      tags.indexOf('ispreorder') > -1 ||
      tags.indexOf('preorder') > -1
    ) {
      return true;
    }

    return !!(product.variants || []).some(function(variant) {
      return variant.inventory_management === 'shopify' &&
        variant.inventory_policy === 'continue' &&
        variant.available === true;
    });
  }

  function getCustomBadges(product) {
    var tags = product && product.tags ? product.tags : [];

    return tags
      .filter(function(tag) {
        return /^badge_/i.test(tag);
      })
      .map(function(tag) {
        return String(tag).replace(/^badge_/i, '').trim();
      })
      .filter(Boolean);
  }

  function getProductMaxQty(product) {
    var first = getFirstVariant(product);

    if (first.inventory_management === 'shopify' && typeof first.inventory_quantity !== 'undefined') {
      return first.inventory_quantity;
    }

    return 9999;
  }

  function variantHasBufferedAvailability(variant) {
    if (!variant || variant.available !== true) return false;

    if (variant.inventory_management === 'shopify') {
      var inventoryQuantity = variant.inventory_quantity;

      if (
        inventoryQuantity === null ||
        typeof inventoryQuantity === 'undefined' ||
        inventoryQuantity === ''
      ) {
        return null;
      }

      inventoryQuantity = Number(inventoryQuantity);

      if (isNaN(inventoryQuantity)) return null;

      return variant.inventory_policy === 'continue' || inventoryQuantity > 0;
    }

    return true;
  }

  function productHasBufferedAvailability(product, fallbackAvailable) {
    if (!product || product.available !== true) return false;

    if (typeof fallbackAvailable === 'boolean') return fallbackAvailable;

    return true;
  }

  function updateProductOptions(card, product, handle) {
    var current = safeJsonParse(card.getAttribute('data-product-options'));
    var first = getFirstVariant(product);
    var customBadges = getCustomBadges(product);
    var fallbackAvailable = typeof current.available === 'boolean' ? current.available : undefined;
    var bufferedAvailable = productHasBufferedAvailability(product, fallbackAvailable);

    current.id = product.id;
    current.handle = handle || product.handle;
    current.available = bufferedAvailable;
    current.isDefault = product.variants && product.variants.length === 1;
    current.VariantFirstID = first.id || null;
    current.customBadge = customBadges;
    current.customBadgeHandle = customBadges.map(handleize);
    current.dateStart = product.created_at ? Math.floor(Date.parse(product.created_at) / 1000) : current.dateStart;
    current.compare_at_price = first.compare_at_price || null;
    current.price = first.price || product.price || null;
    current.isPreoder = productIsPreorder(product);
    current.maxQuantity = getProductMaxQty(product);

    card.setAttribute('data-product-options', JSON.stringify(current));
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/`/g, '&#096;');
  }

  function badgeSpan(type, label, style) {
    return '<span class="t4s-badge-item t4s-badge-' + type + '"' + (style ? ' style="' + style + '"' : '') + '>' + escapeHtml(label) + '</span>';
  }

  function tagSettingMatches(product, settingValue, blankMatchesAll) {
    var setting = String(settingValue || '').trim().toLowerCase();

    if (!setting) return !!blankMatchesAll;
    if (setting === 'all') return true;

    var productTags = (product && product.tags ? product.tags : []).map(function(tag) {
      return String(tag || '').trim().toLowerCase();
    });

    return setting.split(',').some(function(tag) {
      tag = String(tag || '').trim().toLowerCase();
      return tag && productTags.indexOf(tag) > -1;
    });
  }

  function setBadgeDisplay(el) {
    if (!el) return;
    var shouldShow = arguments.length > 1 ? arguments[1] : true;

    if (shouldShow) {
      el.classList.remove('if-badge-force-hidden');
      el.style.removeProperty('display');
    } else {
      el.classList.add('if-badge-force-hidden');
    }
  }

  function setBadgeGroupDisplay(elements, shouldShow) {
    elements.forEach(function(el) {
      setBadgeDisplay(el, shouldShow);
    });
  }

  function badgeMatchForTarget(card, product, productHandle, targetType, tagSetting, collectionHandle, initialCollectionMatch, requestToken, callback) {
    if (!badgeRequestIsCurrent(card, requestToken)) return;

    if (!product || /gift card/i.test(product.title || '')) {
      callback(false);
      return;
    }

    var normalizedTargetType = String(targetType || 'tag').trim().toLowerCase();
    var normalizedTagSetting = String(tagSetting || '').trim();

    /*
      Important:
      Do NOT use the current collection page handle as a fallback here.
      That made every product on that collection page show the badge.

      For collection targeting we verify the selected/rendered colour product itself
      by scanning /collections/{collection}/products.json.

      Do NOT compare against getCurrentHandle() inside the async callback.
      After a swatch switch-back, the theme can temporarily leave links/active classes stale,
      which was preventing the badge from coming back. The request token below is the safe
      stale-result guard.
    */
    if (normalizedTargetType === 'collection' || (!normalizedTagSetting && collectionHandle)) {
      if (!collectionHandle) {
        callback(false);
        return;
      }

      productMatchesCollection(productHandle || product.handle, collectionHandle).then(function(matches) {
        if (!badgeRequestIsCurrent(card, requestToken)) return;
        callback(!!matches);
      }).catch(function() {
        if (!badgeRequestIsCurrent(card, requestToken)) return;
        callback(false);
      });

      return;
    }

    callback(tagSettingMatches(product, tagSetting, false));
  }

  function updateThemePromoBadges(card, product, productHandle, requestToken) {
    if (!card || !product) return;

    productHandle = productHandle || product.handle || getCurrentHandle(card);

    var extraEl = card.querySelector('[data-if-bottom-promo-badge]');
    var mobileExtraEl = card.querySelector('[data-if-mobile-under-image-promo-badge]');
    var secondaryEl = card.querySelector('[data-if-secondary-image-badge]');

    var extraEnabled = window._ifCardBadgeConfig[0];
    var extraText = window._ifCardBadgeConfig[1];
    var extraTags = window._ifCardBadgeConfig[2];
    var extraTargetType = window._ifCardBadgeConfig[3];
    var extraCollectionHandle = window._ifCardBadgeConfig[4];
    var extraCollectionMatchedAtRender = extraEl ? extraEl.getAttribute('data-if-collection-match') === 'true' : false;

    var secondaryEnabled = window._ifCardBadgeConfig[5];
    var secondaryText = window._ifCardBadgeConfig[6];
    var secondaryTags = window._ifCardBadgeConfig[7];
    var secondaryTargetType = window._ifCardBadgeConfig[8];
    var secondaryCollectionHandle = window._ifCardBadgeConfig[9];
    var secondaryCollectionMatchedAtRender = secondaryEl ? secondaryEl.getAttribute('data-if-collection-match') === 'true' : false;

    if (!extraEnabled || !extraText) {
      setBadgeGroupDisplay([extraEl, mobileExtraEl], false);
    } else {
      /*
        Do not hide immediately for collection-targeted badges.
        Kalles lazyload/gallery JS can mutate the card shortly after render; keeping
        the Liquid-rendered state visible prevents the badge flashing on then
        disappearing while the async collection check catches up.
      */
      badgeMatchForTarget(card, product, productHandle, extraTargetType, extraTags, extraCollectionHandle, extraCollectionMatchedAtRender, requestToken, function(showExtra) {
        if (!badgeRequestIsCurrent(card, requestToken)) return;
        setBadgeGroupDisplay([extraEl, mobileExtraEl], !!showExtra);
      });
    }

    if (!secondaryEnabled || !secondaryText) {
      setBadgeDisplay(secondaryEl, false);
    } else {
      /*
        Do not hide immediately for collection-targeted badges.
        Wait for badgeMatchForTarget so valid collection badges do not blink away.
      */
      badgeMatchForTarget(card, product, productHandle, secondaryTargetType, secondaryTags, secondaryCollectionHandle, secondaryCollectionMatchedAtRender, requestToken, function(showSecondary) {
        if (!badgeRequestIsCurrent(card, requestToken)) return;
        setBadgeDisplay(secondaryEl, !!showSecondary);
      });
    }
  }

  function renderBadgeHtml(product, badgeEl, fallbackAvailable) {
    var sort = (badgeEl.getAttribute('data-sort') || 'sale,new,soldout,preOrder,custom')
      .split(',')
      .map(function(item) {
        return item.trim();
      })
      .filter(Boolean);

    var customBadges = getCustomBadges(product);
    /* Percentage-off badge intentionally hidden. */
    var saleLabel = '';
    var bufferedAvailable = productHasBufferedAvailability(product, fallbackAvailable);

    var badgeMap = {
      sale: '',
      new: productIsNew(product, badgeEl) ? badgeSpan('new', badgeEl.getAttribute('data-new-label') || 'New') : '',
      soldout: !bufferedAvailable ? badgeSpan('soldout', badgeEl.getAttribute('data-soldout-label') || 'Sold Out') : '',
      preOrder: bufferedAvailable && productIsPreorder(product) ? badgeSpan('preorder', badgeEl.getAttribute('data-preorder-label') || 'Pre Order') : '',
      custom: customBadges.map(function(label) {
        return badgeSpan('custom t4s-badge-' + handleize(label), label);
      }).join('')
    };

    return sort.map(function(type) {
      return badgeMap[type] || '';
    }).join('');
  }

  function refreshCardBadges(card, forcedHandle) {
    if (!card) return;

    var badgeEl = card.querySelector('[data-product-badge]');
    if (!badgeEl) return;

    var handle = forcedHandle || getCurrentHandle(card);
    if (!handle) return;

    var requestToken = createBadgeRequest(card, handle);

    if (
      card.getAttribute('data-dynamic-badge-handle') === handle &&
      badgeEl.getAttribute('data-dynamic-badge-rendered') === 'true'
    ) {
      fetchProduct(handle).then(function(product) {
        if (!badgeRequestIsCurrent(card, requestToken)) return;
        updateThemePromoBadges(card, product, handle, requestToken);
      }).catch(function() {});
      return;
    }

    fetchProduct(handle).then(function(product) {
      if (!badgeRequestIsCurrent(card, requestToken)) return;

      if (!forcedHandle) {
        var currentHandle = getCurrentHandle(card);
        if (currentHandle && currentHandle !== handle) return;
      }

      var currentOptions = safeJsonParse(card.getAttribute('data-product-options'));
      var fallbackAvailable = typeof currentOptions.available === 'boolean' ? currentOptions.available : undefined;

      updateProductOptions(card, product, handle);

      badgeEl.innerHTML = renderBadgeHtml(product, badgeEl, fallbackAvailable);
      updateThemePromoBadges(card, product, handle, requestToken);
      badgeEl.setAttribute('data-dynamic-badge-rendered', 'true');
      card.setAttribute('data-dynamic-badge-handle', handle);

      document.dispatchEvent(new CustomEvent('t4s:collection-badge:updated', {
        bubbles: true,
        detail: {
          card: card,
          product: product,
          handle: handle
        }
      }));
    }).catch(function() {
      var fallbackHandle = getLinkProductHandle(card);
      if (fallbackHandle && fallbackHandle !== handle) {
        refreshCardBadges(card, fallbackHandle);
      }
    });
  }

  function queueRefresh(card, delay) {
    if (!card) return;

    clearTimeout(pendingCards.get(card));

    pendingCards.set(card, setTimeout(function() {
      var pendingHandle = card.getAttribute('data-if-pending-badge-handle') || '';
      refreshCardBadges(card, pendingHandle || undefined);
    }, delay || 80));
  }

  function bindCard(card) {
    if (!card || card.getAttribute('data-dynamic-badges-bound') === 'true') return;

    card.setAttribute('data-dynamic-badges-bound', 'true');

    queueRefresh(card, 0);

    var observer = new MutationObserver(function(mutations) {
      var shouldRefresh = mutations.some(function(mutation) {
        if (mutation.type === 'attributes') {
          return mutation.attributeName === 'href' ||
            mutation.attributeName === 'data-product-options';
        }

        if (mutation.type === 'childList') {
          /*
            Ignore image/media lazyload and gallery DOM changes.
            Those fire about a second after load in Kalles and were causing
            valid badges to refresh against stale product handles and disappear.
          */
          return !(mutation.target.closest && mutation.target.closest('.t4s-product-inner'));
        }

        return false;
      });

      if (shouldRefresh) queueRefresh(card, 120);
    });

    observer.observe(card, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['href', 'data-product-options']
    });
  }

  function bindAllCards(root) {
    (root || document).querySelectorAll('.t4s-product').forEach(bindCard);
  }

  document.addEventListener('click', function(event) {
    var swatch = event.target.closest('.t4s-product-colors .t4s-pr-color__item, .t4s-product-colors [data-handle], .t4s-product-colors [data-product-handle]');
    if (!swatch) return;

    var card = swatch.closest('.t4s-product');
    if (!card) return;

    var swatchHandle = getSwatchProductHandle(swatch);

    card.removeAttribute('data-if-active-badge-handle');

    if (swatchHandle) {
      card.setAttribute('data-if-pending-badge-handle', swatchHandle);
    } else {
      card.removeAttribute('data-if-pending-badge-handle');
    }

    /* Hide the campaign badge while the selected colour product is being checked.
       This prevents the previous colour's badge from lingering on the new rendered card. */
    setBadgeDisplay(card.querySelector('[data-if-secondary-image-badge]'), false);

    [0, 80, 250, 700, 1200, 2000].forEach(function(delay) {
      setTimeout(function() {
        refreshCardBadges(card, swatchHandle || undefined);
      }, delay);
    });

    /*
      Keep the clicked swatch handle for longer than the theme's re-render window.
      This is what fixes switching away and then back: the full-width/title links can
      lag behind the selected swatch, so the clicked handle is the source of truth.
    */
    setTimeout(function() {
      if (swatchHandle && card.getAttribute('data-if-pending-badge-handle') === swatchHandle) {
        card.removeAttribute('data-if-pending-badge-handle');
      }
      refreshCardBadges(card);
    }, 3200);
  }, true);

  function bootDynamicBadges(root) {
    bindAllCards(root || document);
  }

  window._t4sBindDynamicCollectionBadges = bootDynamicBadges;

  document.addEventListener('t4s:collection:updated', function() {
    bootDynamicBadges(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    bootDynamicBadges(event.target);
  });

  document.addEventListener('shopify:section:select', function(event) {
    bootDynamicBadges(event.target);
  });

  window.addEventListener('pageshow', function() {
    bootDynamicBadges(document);
  });

  window.addEventListener('load', function() {
    bootDynamicBadges(document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      bootDynamicBadges(document);
      setTimeout(function(){ bootDynamicBadges(document); }, 150);
      setTimeout(function(){ bootDynamicBadges(document); }, 600);
    });
  } else {
    bootDynamicBadges(document);
    setTimeout(function(){ bootDynamicBadges(document); }, 150);
    setTimeout(function(){ bootDynamicBadges(document); }, 600);
  }

  if (window.MutationObserver) {
    var pageObserver = new MutationObserver(function(mutations) {
      var shouldBind = mutations.some(function(mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function(node) {
          return node.nodeType === 1 && (
            node.matches && node.matches('.t4s-product') ||
            node.querySelector && node.querySelector('.t4s-product')
          );
        });
      });

      if (shouldBind) bootDynamicBadges(document);
    });

    if (document.body) {
      pageObserver.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        if (document.body) pageObserver.observe(document.body, { childList: true, subtree: true });
      });
    }
  }
})();

/* ===== IF mobile swipe on the card image ===== */
(function () {
  var MOBILE = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  if (!MOBILE) return;

  var MIN_X = 35, startX = 0, startY = 0, tracking = null, swipedAt = 0;

  document.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) { tracking = null; return; }
    var inner = e.target.closest && e.target.closest('.if-card-image-arrows-enabled .t4s-product-inner');
    tracking = inner || null;
    if (inner) { startX = e.touches[0].clientX; startY = e.touches[0].clientY; }
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (!tracking) return;
    var t = e.changedTouches && e.changedTouches[0];
    var card = tracking;
    tracking = null;
    if (!t) return;
    var dx = t.clientX - startX, dy = t.clientY - startY;
    if (Math.abs(dx) < MIN_X || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    var btn = card.querySelector(dx < 0 ? '[data-if-card-image-next]' : '[data-if-card-image-prev]');
    if (!btn) return;
    swipedAt = Date.now();
    btn.click();
  }, { passive: true });

  document.addEventListener('click', function (e) {
    if (Date.now() - swipedAt > 500) return;
    var inner = e.target.closest && e.target.closest('.if-card-image-arrows-enabled .t4s-product-inner');
    if (!inner) return;
    e.preventDefault();
    e.stopPropagation();
  }, true);
})();
